import { Draggable } from "@hello-pangea/dnd";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import {
  Box,
  IconButton
} from "@mui/material";
import React from "react";
import { ReferenceRow } from "../../types/model/reference";
import { ReferenceRowCells } from "./ReferenceRowCells";
import { ReferenceRowActions } from "./ReferenceRowActions";

interface ReferenceTableRowProps {
  row: ReferenceRow;
  index: number;
  fields: string[];
  t: (key: string) => string;
  onEdit: (row: ReferenceRow) => void;
  onToggleActive: (id: number) => void;
}

export const ReferenceTableRow: React.FC<ReferenceTableRowProps> = ({
  row,
  index,
  fields,
  t,
  onEdit,
  onToggleActive,
}) => (
  <Draggable draggableId={`${row.id}`} index={index}>
    {(provided, snapshot) => (
      <Box
        ref={provided.innerRef}
        {...provided.draggableProps}
        style={provided.draggableProps.style}
        sx={{
          display: "grid",
          gridTemplateColumns: `40px repeat(${fields.length}, 1fr) 140px`,
          gap: 1,
          alignItems: "center",
          px: 3,
          py: 1.25,
          backgroundColor: snapshot.isDragging ? "action.hover" : "background.paper",
          boxShadow: snapshot.isDragging ? 3 : 0,
          "&:hover .id-chip": { opacity: 1 },
          "&:hover": { backgroundColor: "action.hover" },
        }}
      >
        {/* drag handle */}
        <Box sx={{ width: 40 }}>
          <IconButton {...provided.dragHandleProps} sx={{ cursor: "grab" }}>
            <DragIndicatorIcon fontSize="small" />
          </IconButton>
        </Box>

        <ReferenceRowCells row={row} fields={fields} t={t} />

        <ReferenceRowActions
          row={row}
          t={t}
          onEdit={onEdit}
          onToggleActive={onToggleActive}
        />
      </Box>
    )}
  </Draggable>
);
